export default __webpack_public_path__ + "static/ban4-9340a2e41420753d6a069b38fe986ef3.png";